import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getEnabledTableColumn,
  getBrandTableColumn,
} from '@/utils/common/tableColumn'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'name',
        hideField: true,
        edit: false,
        editDesc: false,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
        formatter: ({ row }) => {
          return row.name
        },
      }),
      {
        field: 'type',
        title: this.$t('table.title.service'),
      },
      {
        field: 'agent_type',
        title: this.$t('system.agent_type'),
      },
      {
        field: 'host_type',
        title: this.$t('compute.host.host_type.title'),
        width: 80,
        formatter: ({ cellValue, row }) => {
          let ret = '-'
          if (row.host_type === 'container') {
            ret = this.$t('compute.host.host_type.container.title')
          } else if (row.host_type === 'kvm' || row.host_type === 'hypervisor') {
            ret = this.$t('compute.host.host_type.kvm.title')
          } else if (row.host_type === 'baremetal') {
            ret = this.$t('compute.host.host_type.baremetal.title')
          } else if (row.host_type) {
            ret = row.host_type
          }
          return ret
        },
      },
      getBrandTableColumn(),
      getEnabledTableColumn(),
      getTimeTableColumn({ title: this.$t('system.text_530'), field: 'updated_at' }),
    ]
  },
}
